/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/aria-role */
import { delay, get, has, isEmpty } from 'lodash-es';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import Modal from 'react-modal';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withLastLocation } from 'react-router-last-location';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import injectSaga from 'utils/injectSaga';
import PageHeading from '../../components/PageHeading';
import SectionContainer from '../../components/SectionContainer';

import Config from '../../app.config';
import {
  analytics,
  FRANCHISE_PHASES,
  GEO_LOCATION_STATUS,
  isMobile,
  membershipEntityMap,
  PHASES,
  slugGenerator,
} from '../../utils/common';
import reCaptchaV3Plugin from '../../utils/third-party-plugins/recaptcha-v3';
import Footer from '../Footer';
import Header from '../Header';
import KlaviyoList from '../KlaviyoList';
import {
  clearNearestLocations,
  fetchLocations,
  fetchNearestLocation,
  setBookingFlow,
  setSelectedLocation,
  setGeolocatioStatus,
} from './actions';
import { setHomeLocation } from '../Membership/actions';
import Map from './google-map';
import saga from './saga';
import { appointmentSegmentAnalytics } from './segment';
import makeSelectAppointment from './selectors';
import makeSelectMembership from '../Membership/selectors';
import BackgroundStripped from '../../components/BackgroundStripped';
import LoadingScreen from '../../components/LoadingIndicator';
export const LocationContext = React.createContext({ purchaseFunnel: true });

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    padding: '0px',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '450px',
  },
};

class AppointmentLocations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      purchaseFunnel: !(
        get(queryString.parse(props.location.search), 'purchase_funnel') ===
        'false'
      ),
      showModal: false,
      selectedAddress: '',
      address: '',
      isMarkerClicked: false,
      markedLocation: {},
      isLocationDetailsClicked: false,
      selectedLocationDetails: {},
      changeLocationSeoDesc: false,
      showCurrLocationMarker: true,
      isGeoLocationAccessDenied: false,
      routeToPricing: (
        get(queryString.parse(props.location.search), 'reRoutetoPricing') ===
        'true'
      )
    };
    this.handleScroll = this.handleScroll.bind(this);
    this.handleLocationClick = this.handleLocationClick.bind(this);
    this.renderLocations = this.renderLocations.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.fetchNearestLocation = this.fetchNearestLocation.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleMarkerClick = this.handleMarkerClick.bind(this);
    this.state.changeLocationSeoDesc =
      this.props.location.pathname === '/appointment/locations' &&
      this.props.location.search === '?purchase_funnel=false';
    this.handleLocationsInView = this.handleLocationsInView.bind(this);
    this.handleLocationDetailsClick = this.handleLocationDetailsClick.bind(
      this,
    );
    this.renderLocationListOrBlockedModal = this.renderLocationListOrBlockedModal.bind(
      this,
    );
    this.renderMapOrBlockedModal = this.renderMapOrBlockedModal.bind(this);
    this.renderMarkerOrBlockedModal = this.renderMarkerOrBlockedModal.bind(
      this,
    );
    this.handleCurrentLocationMarkerClick = this.handleCurrentLocationMarkerClick.bind(
      this,
    );
    this.handleGeolocationAccess = this.handleGeolocationAccess.bind(this);
  }

  checkPreliveLocation() {
    const { locations } = this.props.appointmentData;
    if (locations && locations.length > 0) {
      const locationPrelive = locations.filter(
        a => a.launch_status === FRANCHISE_PHASES.PHASE3,
      );
      const loc = locationPrelive.find(a =>
        localStorage.getItem(`${a.url_name}-preLive`),
      );

      return !!(
        loc && localStorage.getItem(`${loc.url_name}-preLive`) === 'true'
      );
    }
    return false;
  }

  componentDidMount() {
    reCaptchaV3Plugin('locations_page');
    const {
      selectedLocation,
      isBuyingRegularMembershipFlow,
    } = this.props.appointmentData;
    this.handleGeolocationAccess();
    const { purchaseFunnel } = this.state;
    if (purchaseFunnel && !isBuyingRegularMembershipFlow) {
      this.props.setBookingFlow('locations');
      // eslint-disable-next-line no-unused-expressions
      !isEmpty(selectedLocation) &&
        this.props.history.push(
          `/appointment/location/${
            selectedLocation.id
          }/services/${slugGenerator(selectedLocation.url_name)}`,
        );
    }
    delay(() => {
      appointmentSegmentAnalytics(
        'Choose Location',
        { ...this.props },
        ['Category', 'Logged_In', 'Referring_Page_Title'],
        'page',
      );
    }, 50);
  }

  fetchNearestLocation(latLgn = {}) {
    const {
      isBuyingRegularMembershipFlow,
      geoLocationStatus,
    } = this.props.appointmentData;
    if (!isEmpty(latLgn) && geoLocationStatus === GEO_LOCATION_STATUS.GRANTED) {
      this.props.fetchNearestLocation(
        '',
        latLgn,
        isBuyingRegularMembershipFlow,
      );
    } else if (has(this.props.appointmentData, 'ipAddress')) {
      const { ipAddress } = this.props.appointmentData;
      this.props.fetchNearestLocation(
        // eslint-disable-next-line no-undef
        ipAddress?.ip ? ipAddress.ip : '',
        latLgn,
        isBuyingRegularMembershipFlow,
      );
    } else {
      this.props.fetchNearestLocation('', {}, isBuyingRegularMembershipFlow);
    }
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  handleLocationDetailsClick(location) {
    let totalOffsetHeight = 0;
    const locs = this.props.appointmentData.nearestLocations.items;
    for (let i = 0; i < locs.length; i += 1) {
      if (i < location.serialNo - 1) {
        const div = document.getElementById(locs[i].id);
        if (div) {
          const currOffsetHeight = div.offsetHeight;
          totalOffsetHeight += currOffsetHeight;
        } else {
          totalOffsetHeight += totalOffsetHeight;
        }
      }
    }
    this.handleScroll(location, totalOffsetHeight);
  }

  handleMarkerClick(location) {
    let totalOffsetHeight = 0;
    const locs = this.props.appointmentData.nearestLocations.items;
    for (let i = 0; i < locs.length; i += 1) {
      if (i < location.serialNo - 1) {
        const div = document.getElementById(locs[i].id);
        if (div) {
          const currOffsetHeight = div.offsetHeight;
          totalOffsetHeight += currOffsetHeight;
        }
      }
    }
    this.setState({ isMarkerClicked: true });
    this.setState({ isLocationDetailsClicked: false });
    this.setState({ markedLocation: location });
    this.handleScroll(location, totalOffsetHeight);
  }

  handleScroll(location, totalOffsetHeight) {
    if (isMobile()) {
      const parent = document.querySelector('.MainContentWrap');
      parent.classList.add('page__scroll');
      parent.scrollTo({
        top: location.serialNo === 1 ? 0 : totalOffsetHeight + 68,
        left: 0,
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start',
      });
    } else {
      const parent = document.querySelector('.loactions-list');
      parent.scrollTo({
        top: location.serialNo === 1 ? 0 : totalOffsetHeight,
        left: 0,
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start',
      });
    }
  }

  handleLocationsInView(locations) {
    if (locations) {
      if (locations[0]) {
        const element = document.getElementById(locations[0].id);
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start',
        });
      }
    }
  }

  handleGeolocationAccess() {
    if (!('geolocation' in navigator)) {
      this.props.setGeolocatioStatus(GEO_LOCATION_STATUS.NOT_SUPPORTED);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      position => {
        const { latitude, longitude } = position.coords;
        this.fetchNearestLocation({ lat: latitude, lng: longitude });
        this.setState({ isGeoLocationAccessDenied: false });
        this.props.setGeolocatioStatus(GEO_LOCATION_STATUS.GRANTED);
      },
      // eslint-disable-next-line no-unused-vars
      error => {
        this.fetchNearestLocation({});
        this.setState({ isGeoLocationAccessDenied: true });
        this.props.setGeolocatioStatus(GEO_LOCATION_STATUS.DENIED);
      },
    );
  }

  handleLocationPermissionModal() {
    const { isGeoLocationAccessDenied } = this.state;
    return (
      <Modal isOpen={isGeoLocationAccessDenied} style={customStyles}>
        <div className="text-center NotifyTherapistModal">
          <button
            type="button"
            className="modal__close btn-icon icon js-modal-close"
            onClick={() =>
              this.setState({
                isGeoLocationAccessDenied: false,
              })
            }
          >
            <span className="screenreader">Close</span>
          </button>
          <div className="bubble">
            <p className="NotifyTherapistModal-bubble-text">
              Enable location permissions on your browser to get the most
              accurate results
            </p>
          </div>
          <div className="preg-modal__smiley">
            <i className="icon icon--smiley-blue-reflection" />
          </div>
          <div className="own-action-btn pb20-mb pt20">
            <div
              aria-label="geo-location-denied"
              className="btn btn--primary"
              onClick={() =>
                this.setState({
                  isGeoLocationAccessDenied: false,
                })
              }
            >
              OKAY
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  // eslint-disable-next-line consistent-return
  handleLocationClick ( location )
  {    
    const { selectedService } = this.props.appointmentData;
    const isFromTherapistRoute =
      this.props.location && this.props.location.state === 'TherapistRoute';
    if (location) {
      this.props.setBookingFlow('locations');
      if (
        location.is_active &&
        location.launch_status !== FRANCHISE_PHASES.PHASE3
      ) {
        this.props.setSelectedLocation(location);
      }
      const pathname = get( this.props, 'lastLocation.pathname' );
      
      if (this.checkPrelive(location) && location) {
        this.props.setSelectedLocation(location);
        if (isFromTherapistRoute) {
          this.props.history.push('/therapist/list');
        } else
          this.props.history.push(
            `/appointment/location/${location.id}/services/${slugGenerator(
              location.url_name,
            )}`,
          );
        return null;
      }
      if (
        location &&
        location.is_active &&
        location.launch_status === FRANCHISE_PHASES.PHASE3
      ) {
        this.props.history.push({
          pathname: `/appointment/location/${
            location.id
          }/more-info/${slugGenerator(location.url_name)}`,
        });
        return null;
      }
      if (
        location &&
        !location.is_active &&
        PHASES.includes(location.launch_status)
      ) {
        this.props.history.push({
          pathname: `/appointment/location/${
            location.id
          }/more-info/${slugGenerator(location.url_name)}`,
        });
        return null;
      }
      if (
        location &&
        !location.is_active &&
        !isEmpty(location.coming_soon_message)
      ) {
        return this.setState({ showModal: true });
      }

      appointmentSegmentAnalytics(
        'Subscribed',
        { ...this.props },
        ['Category'],
        'track',
      );

      delay(() => {
        appointmentSegmentAnalytics(
          'Locations - Book Now',
          { ...this.props },
          ['Location Name'],
          'track',
        );
      }, 50);

      if (isFromTherapistRoute && location.is_active) {
        this.props.history.push('/therapist/list');
      } else if (
        !isEmpty(selectedService) &&
        get(selectedService, 'location_id') === location.id &&
        pathname === '/pricing'
      ) {
        this.props.history.push({
          pathname: `/appointment/location/${
            location.id
          }/massage-types/${slugGenerator(location.name)}`,
          search: `?is_membership=${false}`,
        });
      } else
        this.props.history.push(
          `/appointment/location/${location.id}/services/${slugGenerator(
            location.url_name,
          )}`,
        );
    }
  }

  checkPrelive(loc) {
    return (
      loc.url_name &&
      loc.is_active &&
      loc.launch_status === FRANCHISE_PHASES.PHASE3 &&
      localStorage.getItem(`${loc.url_name}-preLive`) === 'true'
    );
  }

  renderButtonLabel(loc) {
    const { isBuyingRegularMembershipFlow } = this.props.appointmentData;
    if (loc.is_active && !loc.launch_status) {
      return isBuyingRegularMembershipFlow ? 'Select' : 'Book Here';
    } else if (this.checkPrelive(loc)) {
      return 'Book Here';
    } else if (PHASES.includes(loc.launch_status)) {
      return 'Learn More';
    } else if (loc.coming_soon_message) {
      return 'Get Notified';
    }
    return '';
  }

  handleHomeLocationOnChange(location) {
    const { id } = location;

    this.props.setSelectedLocation(location);
    this.props.setHomeLocation(id);
    const { membershipDetails } = this.props.membershipData;
    const isMember =
      !isEmpty(membershipDetails) &&
      membershipEntityMap[get(membershipDetails, 'entity_status_id')] ===
        'active';
    analytics(
      'Select Home Location',
      {
        'Membership Status': isMember
          ? membershipDetails.description
          : 'Non-Member',
        'Home Location': id || 'N/A',
      },
      false,
    );

   this.props.history.push( this.state.routeToPricing ? '/pricing' : '/membership');
  }

  handleLocation(loc) {
    const location = loc && (loc.is_active || loc.launch_status);
    const { purchaseFunnel } = this.state;
    const { isBuyingRegularMembershipFlow } = this.props.appointmentData;

    return location && !purchaseFunnel && !isBuyingRegularMembershipFlow ? (
      <div>
        <a
          aria-label="location-more-info-page"
          href={`/appointment/location/${loc.id}/more-info/${slugGenerator(
            loc.url_name,
          )}`}
          className="locations-list-item__linkout location-title"
          target="_blank"
          onClick={() => {
            analytics('Individual Location', { 'Location Name': loc.city });
          }}
        >
          <h4 className="location-title"> {loc.name}</h4>
        </a>
      </div>
    ) : (
      <div>
        <h4 className="location-title"> {loc.name}</h4>
      </div>
    );
  }

  buttonClassName(loc) {
    const location =
      (loc.is_active && !loc.launch_status) || this.checkPrelive(loc);
    return !location
      ? 'btn--secondary btn w-150 outline-btn'
      : 'btn--secondary btn w-150';
  }

  formateAddress(loc) {
    if (!loc.launch_status && loc.is_active) {
      return (
        <>
          <h6 className="location-sub1">{loc.address}</h6>
          <h6 className="location-sub2">
            {loc.city}, {loc.state} {loc.zip}
          </h6>
        </>
      );
    }
    return (
      <>
        <h6 className="location-sub1">{loc.address.split(',')[0]}</h6>
        <h6 className="location-sub2">
          {loc.city}, {loc.state} {loc.zip ? ` ${loc.zip}` : ''}
          <br />
          {loc.coming_soon_message || ''}
        </h6>
      </>
    );
  }

  renderLocations(locations, markedLocation) {
    const { isBuyingRegularMembershipFlow } = this.props.appointmentData;
    let height = 0;
    let width = 0;
    if (locations[0]) {
      const div = document.getElementById(locations[0].id);
      if (div) {
        height = div.offsetHeight;
        width = div.offsetWidth;
      }
    }
    return (
      <div>
        {locations &&
          locations.map(loc => (
            <div
              role="location-details"
              styling="link"
              onClick={() => {
                this.setState({ selectedLocationDetails: loc });
                this.setState({ isLocationDetailsClicked: true });
                this.handleLocationDetailsClick(loc);
              }}
              key={loc.id}
              className={
                (loc.id === this.state.selectedLocationDetails.id &&
                  this.state.isLocationDetailsClicked) ||
                (markedLocation.id === loc.id &&
                  this.state.isMarkerClicked &&
                  !this.state.isLocationDetailsClicked)
                  ? 'list-item-wrap selected'
                  : 'list-item-wrap'
              }
              id={loc.id}
            >
              <div className="locations-wrap">
                <div className="miles-wrap">
                  {loc.distance.value !== '0.00' ? (
                    <div className="miles-text">{loc.distance.text}</div>
                  ) : (
                    <div />
                  )}
                  <div
                    className={
                      (loc.id === this.state.selectedLocationDetails.id &&
                        this.state.isLocationDetailsClicked) ||
                      (markedLocation.id === loc.id &&
                        this.state.isMarkerClicked &&
                        !this.state.isLocationDetailsClicked)
                        ? 'serial-number-style selected'
                        : 'serial-number-style'
                    }
                  >
                    {loc.serialNo}
                  </div>
                </div>
                <div className="location-detail">
                  <div>
                    {this.handleLocation(loc)}
                    {this.formateAddress(loc)}
                  </div>
                  <div>
                    {isBuyingRegularMembershipFlow ? (
                      <button
                        className={this.buttonClassName(loc)}
                        onClick={() => {
                          this.handleHomeLocationOnChange(loc);
                        }}
                      >
                        {' '}
                        {this.renderButtonLabel(loc)}
                      </button>
                    ) : (
                      <button
                        className={this.buttonClassName(loc)}
                        onClick={() => {
                          this.handleLocationClick(loc);
                        }}
                      >
                        {' '}
                        {this.renderButtonLabel(loc)}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        {!isMobile() ? (
          <div>
            <div id="10000" style={{ width, height }} />
            <div id="10001" style={{ width, height }} />
          </div>
        ) : null}
      </div>
    );
  }

  handleChange = address => {
    this.setState({ address });
  };

  handleSearch(address) {
    const div = document.querySelector('.loactions-list');
    if (div) {
      div.scrollTo({
        left: 0,
        top: 0,
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start',
      });
    }
    this.setState({ isMarkerClicked: false });
    this.setState({ isLocationDetailsClicked: false });
    const { selectedAddress } = this.state;
    const addr = address || selectedAddress;
    geocodeByAddress(addr)
      .then(results => getLatLng(results[0]))
      .then(latLng => this.handleSuccess(latLng));
  }

  handleSuccess(latLng) {
    this.fetchNearestLocation(latLng);
  }

  /* Show location list based based on location access */
  renderLocationListOrBlockedModal(nearestLocations, markedLocation) {
    return (
      <div className="loactions-list">
        {this.renderLocations(nearestLocations, markedLocation)}
      </div>
    );
  }

  handleCurrentLocationMarkerClick() {
    this.setState({ selectedAddress: '' });
    this.setState({ address: '' });
    this.fetchNearestLocation({});
  }

  /* Show location access marker based based on location access */
  renderMarkerOrBlockedModal(showCurrLocationMarker) {
    if (!showCurrLocationMarker) {
      return <div />;
    }
    return (
      <button
        id="currentLocationSearch"
        className="btn btn--secondary--loc"
        onClick={this.handleCurrentLocationMarkerClick}
      >
        <img
          className="searchIcon"
          src={`${Config.awsCloudFrontUrl}/svg/current-location.svg`}
          height="24px"
          width="24px"
          alt="Current Location Icon"
        />
      </button>
    );
  }

  /* Show map based based on location access */
  renderMapOrBlockedModal(nearestLocations) {
    return (
      window.google && (
        <Map
          isMarkerClicked={this.state.isMarkerClicked}
          handleLocationsInView={this.handleLocationsInView}
          isLocationDetailsClicked={this.state.isLocationDetailsClicked}
          selectedLocationDetails={this.state.selectedLocationDetails}
          locations={nearestLocations}
          handleMarkerClick={this.handleMarkerClick}
          handleListReactionToZoom={this.handleListReactionToZoom}
        />
      )
    );
  }

  filterActiveLocations = nearestLocations => {
    const activeLocations = nearestLocations.filter(
      loc => loc.launch_status === null && loc.is_active === 1,
    );
    // eslint-disable-next-line no-return-assign, no-param-reassign
    activeLocations.forEach((loc, index) => (loc.serialNo = index + 1));
    return activeLocations;
  };

  render() {
    const { purchaseFunnel } = this.state;
    const headerProps = !purchaseFunnel
      ? {
          showHamburgerMenu: true,
        }
      : { showCloseButton: true };

    // eslint-disable-next-line no-underscore-dangle
    const {
      fetchLocationsError,
      nearestLocations,
    } = this.props.appointmentData;

    if (fetchLocationsError) {
      return <span>{fetchLocationsError}</span>;
    }

    const { isBuyingRegularMembershipFlow } = this.props.appointmentData;
    if (isEmpty(nearestLocations)) {
      return (
        <LoadingScreen
          loaderMessage="Loading locations list...please wait!"
          hangTight
        />
      );
    }

    return (
      <Fragment>
        <LocationContext.Provider
          value={{
            purchaseFunnel,
            handleLocationClick: location => this.handleLocationClick(location),
          }}
        >
          <div className="appWrap">
            {this.state.changeLocationSeoDesc && (
              <Helmet titleTemplate="%s - Squeeze" defaultTitle="Squeeze">
                <title>
                  A Way Better Massage Experience | Appointments | Squeeze
                  Massage
                </title>
                <meta
                  name="description"
                  content="Find a Massage Near You | Squeeze Locations Looking for the closest Squeeze location to you? Click here to search for the Squeeze location closest to you."
                  data-react-helmet="true"
                />
                <meta
          name="keywords"
          content="locations, Squeezemassage, find a massage, massage near me"
        />
              </Helmet>
            )}
            <div className={`MainContentWrap ${isMobile() && 'page__scroll'}`}>
              <Header {...headerProps} />
              <div className="footerMarginContainer mt3">
                {isBuyingRegularMembershipFlow ? (
                  <>
                    <PageHeading
                      mobileTitle="LESS FEES, MORE SQUEEZE"
                      pathname={this.props.location.pathname}
                    >
                      LESS FEES, MORE SQUEEZE
                    </PageHeading>
                    <BackgroundStripped>
                      CHOOSE THE SHOP {"YOU'D"} VISIT MOST OFTEN AS A MEMBER
                    </BackgroundStripped>
                  </>
                ) : (
                  <PageHeading
                    mobileTitle="Pick your place"
                    pathname={this.props.location.pathname}
                  >
                    Pick your place
                  </PageHeading>
                )}
                <SectionContainer>
                  <div className="locations_root">
                    <div className="grid_map_list">
                      {this.renderLocationListOrBlockedModal(
                        nearestLocations.items,
                        this.state.markedLocation,
                      )}
                      <div className="relative sticky__mob">
                        <div className="locations-search-bar flex-center align-items-baseline newFranchise">
                          <div className="relative">
                            {window.google && (
                              <PlacesAutocomplete
                                value={this.state.address}
                                onChange={address => {
                                  this.setState({ address });
                                }}
                                onSelect={address => {
                                  this.setState({
                                    selectedAddress: address,
                                  });
                                  this.setState({ address });
                                  this.handleSearch(address);
                                }}
                                searchOptions={{
                                  // types: ['address'],
                                  componentRestrictions: { country: 'us' },
                                }}
                              >
                                {({
                                  getInputProps,
                                  suggestions,
                                  getSuggestionItemProps,
                                  loading,
                                }) => (
                                  <div>
                                    <input
                                      {...getInputProps({
                                        placeholder:
                                          'Search address, city, state, or zip code',
                                        className:
                                          'location-search-input input locations-place',
                                        autoFocus: true,
                                      })}
                                    />
                                    <div className="autocomplete-dropdown-container">
                                      {loading && (
                                        <p className="text-center mt20">
                                          Loading...
                                        </p>
                                      )}
                                      {suggestions.map(suggestion => {
                                        const className = suggestion.active
                                          ? 'suggestion-item--active'
                                          : 'suggestion-item';
                                        // inline style for demonstration purpose
                                        const style = suggestion.active
                                          ? {
                                              backgroundColor: '#fafafa',
                                              cursor: 'pointer',
                                            }
                                          : {
                                              backgroundColor: '#ffffff',
                                              cursor: 'pointer',
                                            };
                                        return (
                                          <div
                                            {...getSuggestionItemProps(
                                              suggestion,
                                              {
                                                className,
                                                style,
                                              },
                                            )}
                                            className="locationDrop"
                                          >
                                            <span>
                                              {suggestion.description}
                                            </span>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
                                )}
                              </PlacesAutocomplete>
                            )}
                            {this.renderMarkerOrBlockedModal(
                              this.state.showCurrLocationMarker,
                            )}
                            <button
                              id="handleSearch"
                              className="btn btn--secondary--search"
                              onClick={() => {
                                this.handleSearch(this.state.address);
                              }}
                            >
                              <img
                                className="searchIcon"
                                src={`${
                                  Config.awsCloudFrontUrl
                                }/svg/search-icon-1.svg`}
                                alt="search Icon"
                                height="24px"
                                width="24px"
                              />
                            </button>
                          </div>
                        </div>
                        <div className="locations-map" id="google-map">
                          {this.renderMapOrBlockedModal(nearestLocations.items)}
                        </div>
                      </div>
                    </div>
                  </div>
                </SectionContainer>
              </div>
              {this.handleLocationPermissionModal()}
            </div>
            <div className="FootContentWrap">
              <Footer
                showItems={!purchaseFunnel && !isBuyingRegularMembershipFlow}
                hideMobile
              />
            </div>
          </div>
        </LocationContext.Provider>
        <Modal isOpen={this.state.showModal} style={customStyles}>
          <div className="NotifyTherapistModal" style={{ textAlign: 'center' }}>
            <button
              type="button"
              className="modal__close btn-icon icon js-modal-close"
              onClick={() => this.closeModal()}
            >
              <span className="screenreader">Close</span>
            </button>
            <div className="bubble">
              <p className="NotifyTherapistModal-bubble-text">
                {"We'll email you when we open!"}
              </p>
              <i className="notifyInfoIcon get-notified--emojis location-emoji" />
            </div>
            <div className="preg-modal__smiley">
              <i className="icon icon--smiley-blue-reflection" />
            </div>
            <KlaviyoList
              type="franchise"
              onCloseModal={this.closeModal}
              {...this.props}
            />
          </div>
        </Modal>
      </Fragment>
    );
  }
}

AppointmentLocations.propTypes = {
  membershipData: PropTypes.object,
  appointmentData: PropTypes.object,
  location: PropTypes.object,
  history: PropTypes.object,
  clearNearestLocations: PropTypes.func,
  fetchLocations: PropTypes.func,
  fetchNearestLocation: PropTypes.func,
  setBookingFlow: PropTypes.func,
  setSelectedLocation: PropTypes.func,
  setHomeLocation: PropTypes.func,
  setGeolocatioStatus: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  appointmentData: makeSelectAppointment(),
  membershipData: makeSelectMembership(),
});

const withConnect = connect(
  mapStateToProps,
  {
    fetchLocations,
    setSelectedLocation,
    setBookingFlow,
    fetchNearestLocation,
    clearNearestLocations,
    setHomeLocation,
    setGeolocatioStatus,
  },
);
const withSagaFetchLocations = injectSaga({
  key: 'fetchLocations',
  saga: saga.watchFetchLocations,
});

const withSagaNearestLocation = injectSaga({
  key: 'fetchNearestLocation',
  saga: saga.watchNearestLocation,
});

export default compose(
  withRouter,
  withConnect,
  withSagaFetchLocations,
  withLastLocation,
  withSagaNearestLocation,
)(AppointmentLocations);
